<script>
export default {
  methods: {
    setEqualHeight (destination, target, value) {
      setTimeout(() => {
        const elements = destination.querySelectorAll(target)

        if (value) {
          let maxHeight = 0

          elements.forEach((element, index) => {
            const currentHeight = element.clientHeight
            if (currentHeight > maxHeight) {
              maxHeight = currentHeight
            }
          })

          elements.forEach((element, index) => {
            element.setAttribute('style', `height: ${maxHeight}px;`)
          })
        } else {
          elements.forEach((element, index) => {
            element.removeAttribute('style')
          })
        }
      }, 300)
    }
  }
}
</script>
